import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center px-6"
      style={{ backgroundImage: "url('/images/bg.png')" }}
    >
      <div className="bg-white/80 backdrop-blur-lg rounded-3xl shadow-xl p-10 text-center max-w-xl w-full">
        <h1 className="text-7xl font-serif text-[#1f3d2b] mb-4">404</h1>

        <h2 className="text-2xl font-serif text-[#1f3d2b] mb-3">
          {t("notFound.title")}
        </h2>

        <p className="text-gray-600 mb-6">{t("notFound.desc")}</p>

        <div className="flex justify-center gap-4">
          <Link to="/">
            <button className="bg-[#1f3d2b] text-white px-6 py-3 rounded-full hover:opacity-90 transition">
              {t("notFound.home")}
            </button>
          </Link>

          <Link to="/products">
            <button className="border border-[#1f3d2b] text-[#1f3d2b] px-6 py-3 rounded-full hover:bg-[#1f3d2b] hover:text-white transition">
              {t("notFound.products")}
            </button>
          </Link>
        </div>

        <div className="mt-8 text-sm text-[#c9a45c]">
          {t("notFound.tagline")}
        </div>
      </div>
    </div>
  );
}
